import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_RegisterAllocationAssignment = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Register Allocation and Assignment"
    videos={[
      "https://www.youtube.com/embed/J7DmP1hsd00",
      "https://www.youtube.com/embed/4G0WTz0KxsU",
      "https://www.youtube.com/embed/OycQMBU9Kao",
    ]}
    takeaways={[]}
    questions={[
      `Consider the following code snippet: 

int main (){
int a=5;
int b=10;
int c=a+b;
int d=c^2;
int e=d/3;
return e;
}

Perform Register allocation and assignment for the given code snippet assuming there are 3 available 
registers R1, R2 and R3. Assume that variable are assigned registers in the order they appear in the code.`
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_RegisterAllocationAssignment;
